import styled from "styled-components";
import CloseCameraIcon from "components/Icons/CloseCameraButton";

export const CameraOverlayContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  z-index: 666;
  height: 44px;
  background: rgba(0, 0, 0, 0.25);
  width: 100vw;
`;

export const CloseButton = styled(CloseCameraIcon)`
  cursor: pointer;
  margin: 12px;
`;
